import { StylesProvider } from '@material-ui/styles';
import { useEffect, useState } from 'react';
import {
  RecoilRoot,
} from 'recoil';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import RecoilCompat from './RecoilCompat';

const options = {};

const AppWrap = () => {
  const [stripePromise, setStripePromise] = useState();
  useEffect(() => {
    setStripePromise(loadStripe(document.body.dataset.stripepublickey))
  }, []);
  return (
    <StylesProvider injectFirst>
      <RecoilRoot>
        { stripePromise ? (
          <Elements stripe={stripePromise} options={options}>
            <RecoilCompat />
          </Elements>
        ) : (
          <RecoilCompat />
        )}
      </RecoilRoot>
    </StylesProvider>
  )
};

export default AppWrap;
